import React from 'react'

export const LeftQuestionBar = ({ index }) => {
    return (
        <div style={{ cursor: "pointer" }}>
            {index + 1}
        </div>
    )
}
